import moment from "moment";

export const DEFAULT_FORMAT = 'DD-MM-YYYY';
export const MAX_DATE = moment().add(5, 'year').toDate()
export const MIN_DATE = moment().add(-20, 'year').toDate()
export const DEFAULT_LOCALE = 'es';
